import React from 'react';
import { DropdownMenuToggler } from '../dropdown-menu-toggler';
import { DropdownMenuItem } from '../dropdown-menu-item';
import { DropdownMenuItemGroup } from '../dropdown-menu-item-group';

const dropdownMenuItemType = (
  <DropdownMenuItem>
    <div />
  </DropdownMenuItem>
).type;
const dropdownMenuItemGroupType = (
  <DropdownMenuItemGroup index={0} label=''>
    <div />
  </DropdownMenuItemGroup>
).type;
const dropdownMenuTogglerType = (<DropdownMenuToggler />).type;
const fragmentType = (<React.Fragment />).type;

const createChildValidator = (isRequired) => (props, propName, componentName) => {
  const childrenProp = props[propName];

  if (childrenProp == null && isRequired) {
    return new Error(`Invalid prop: ${propName} supplied to ${componentName}. ${propName} is marked as required`);
  }

  if (!Array.isArray(childrenProp) || childrenProp.length === 0) {
    return new Error('Select must have more than one child.');
  }

  const flattenChildren = childrenProp.reduce((sum, child) => {
    if (Array.isArray(child)) {
      return [...sum, ...child];
    }
    sum.push(child);
    return sum;
  }, []);

  const hasDropdownMenuToggler = flattenChildren.some((child) => {
    return child && child.type && child.type === dropdownMenuTogglerType;
  });
  if (!hasDropdownMenuToggler) {
    return new Error('Select must have a DropdownMenuToggler');
  }

  if (hasDropdownMenuToggler && flattenChildren.length === 1) {
    return null;
  }

  const validChildrenTypes = [dropdownMenuItemType, dropdownMenuItemGroupType, fragmentType, 'div', 'span', 'button'];

  const oneChildIsNotTogglerOrFalsy = flattenChildren.some((child) => {
    if (!child) {
      return false;
    }

    return (
      (validChildrenTypes.includes(child.type) ||
        typeof child.type === 'function' ||
        (typeof child.type === 'object' && typeof child.type.type === 'function')) &&
      child.type !== dropdownMenuTogglerType
    );
  });

  if (!oneChildIsNotTogglerOrFalsy) {
    return new Error('Child with incorrect type detected');
  }

  return null;
};

export const dropdownMenuChildValidator = createChildValidator(false);
dropdownMenuChildValidator.isRequired = createChildValidator(true);
